import React from 'react'
import Slider from 'react-slick'
import '../../molecules/Banner/Banner.css'
const isValidHttpUrl = (string) => {
    let url

    try {
        url = new URL(string)
    } catch (err) {
        return false
    }

    return url.protocol === 'http:' || url.protocol === 'https:'
}
const CustomBanner = ({ imageObject }) => {
    const settings = {
        dots: true,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
    }

    return (
        <div className="heroCarousel cust">
            <Slider {...settings}>
                {imageObject && imageObject.length
                    ? imageObject.map((data, index) =>
                          data.is_active == 1 ? (
                              <div
                                  className="homeBanner customBanner homeMarginBottom"
                                  style={{ width: '100%', height: '400px' }}
                                  key={`banner_${index}`}
                              >
                                  <img
                                      src={
                                          data.img_url && isValidHttpUrl(data.img_url)
                                              ? data.img_url
                                              : `${global.site_url}/uploads/brand/${data.img_url}`
                                      }
                                      onError={(e) => (e.src = './assets/images/banner.png')}
                                      alt={`banner_${index}`}
                                  />

                                  <div className="bannerContent">
                                      {data.banner_title && <h3>{data.banner_title}</h3>}
                                  </div>

                                  <div className="bannerContent">
                                      {data.banner_description && (
                                          <h1>{data.banner_description}</h1>
                                      )}
                                  </div>
                              </div>
                          ) : null,
                      )
                    : null}
            </Slider>
        </div>
    )
}

export default CustomBanner
